import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Container } from '../../components';

import app1 from '../../public/fitkonnekt/application/app-1.png';
import app2 from '../../public/fitkonnekt/application/app-2.png';
import app3 from '../../public/fitkonnekt/application/app-3.png';
import app4 from '../../public/fitkonnekt/application/app-4.png';
import app5 from '../../public/fitkonnekt/application/app-5.png';
import app6 from '../../public/fitkonnekt/application/app-6.png';
import app7 from '../../public/fitkonnekt/application/app-7.png';
import app8 from '../../public/fitkonnekt/application/app-8.png';
import background from '../../public/fitkonnekt/application/background.png';

import styles from './fk-application.module.css';

function FKApplication() {
  return (
    <section className={styles.application}>
      <AnimationOnScroll
        animateOnce
        duration={1.2}
        offset={400}
        animateIn="animate__fadeInUp"
      >
        <h2 className={styles.application_title}>
          App<span>lication Screens</span>
        </h2>
      </AnimationOnScroll>

      <div className={styles.application_inner}>
        <Image
          alt="background girl image"
          src={background}
          objectFit="cover"
          layout="fill"
        />
        <Container>
          <div className={styles.wrapper}>
            <div className={styles.application_line}>
              <AnimationOnScroll
                animateOnce
                offset={400}
                duration={1.2}
                animateIn="animate__fadeInUp"
                className={styles.application_item}
              >
                <Image
                  alt="fitkonnect app logo"
                  width={403}
                  height={840}
                  src={app1}
                />
              </AnimationOnScroll>

              <AnimationOnScroll
                className={styles.application_item}
                animateOnce
                duration={1.2}
                offset={400}
                animateIn="animate__fadeInUp"
              >
                <Image
                  alt="fitkonnect app search users"
                  width={403}
                  height={1061}
                  src={app2}
                />
              </AnimationOnScroll>

              <AnimationOnScroll
                className={styles.application_item}
                animateOnce
                duration={1.2}
                offset={400}
                animateIn="animate__fadeInUp"
              >
                <Image
                  alt="fitkonnect app user info"
                  width={403}
                  height={1115}
                  src={app3}
                />
              </AnimationOnScroll>
            </div>
            <div className={styles.application_line}>
              <AnimationOnScroll
                className={styles.application_item}
                animateOnce
                duration={1.2}
                offset={400}
                animateIn="animate__fadeInUp"
              >
                <Image
                  alt="fitkonnect app user info"
                  width={403}
                  height={1004}
                  src={app4}
                />
              </AnimationOnScroll>
              <AnimationOnScroll
                className={styles.application_item}
                animateOnce
                duration={1.2}
                offset={400}
                animateIn="animate__fadeInUp"
              >
                <Image
                  alt="fitkonnect app calendar"
                  width={403}
                  height={1061}
                  src={app5}
                />
              </AnimationOnScroll>
              <AnimationOnScroll
                className={styles.application_item}
                animateOnce
                duration={1.2}
                offset={400}
                animateIn="animate__fadeInUp"
              >
                <Image
                  alt="fitkonnect app workout history"
                  width={403}
                  height={840}
                  src={app6}
                />
              </AnimationOnScroll>
            </div>
            <div className={styles.application_line}>
              <AnimationOnScroll
                className={styles.application_item}
                animateOnce
                duration={1.2}
                offset={400}
                animateIn="animate__fadeInUp"
              >
                <Image
                  alt="fitkonnect app create workout"
                  width={403}
                  height={2023}
                  src={app7}
                />
              </AnimationOnScroll>
              <AnimationOnScroll
                className={styles.application_item}
                animateOnce
                duration={1.2}
                offset={400}
                animateIn="animate__fadeInUp"
              >
                <Image
                  alt="fitkonnect app search workout"
                  width={403}
                  height={1159}
                  src={app8}
                />
              </AnimationOnScroll>
            </div>
          </div>
        </Container>
      </div>
    </section>
  );
}

export default FKApplication;
